// src/pages/OGPreviewHealthCheck.jsx
import React, { useState } from "react";
import { fetchOgMeta } from "lib/ogClient";

export default function OGPreviewHealthCheck() {
  const [url, setUrl] = useState("https://example.com");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  const run = async () => {
    setLoading(true);
    setErr("");
    setData(null);
    console.log("[OGCheck] calling fetchOgMeta", url);
    try {
      const d = await fetchOgMeta(url);
      console.log("[OGCheck] success:", d);
      setData(d);
    } catch (e) {
      console.error("[OGCheck] error:", e);
      setErr(String(e.message || e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 720 }}>
      <h1>OG Preview Health Check</h1>
      <p>Tests the OG proxy + client without touching Evidence components.</p>
      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <input
          style={{ flex: 1, padding: 8 }}
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://example.com"
        />
        <button onClick={run} disabled={loading} style={{ padding: "8px 12px" }}>
          {loading ? "Fetching..." : "Fetch"}
        </button>
      </div>

      {err ? <pre style={{ color: "crimson", whiteSpace: "pre-wrap", marginTop: 12 }}>{err}</pre> : null}
      {data ? (
        <div style={{ marginTop: 16 }}>
          <div><b>siteName:</b> {data.siteName}</div>
          <div><b>title:</b> {data.title}</div>
          <div><b>description:</b> {data.description}</div>
          <div><b>image:</b> {data.image}</div>
          <div><b>favicon:</b> {data.favicon}</div>
        </div>
      ) : null}
    </div>
  );
}
